<template>
    <button
        class="relative flex justify-center items-center w-full mb-4 sm:mb-8 lg:mb-0 lg:mx-4 xl:mx-8 py-10 md:py-20 lg:py-32 cursor-pointer overflow-hidden group"
        @click="update()"
    >
        <!-- π ----
        // :: IMAGE
        // : ---------------------------------- -->
        <div class="absolute top-0 left-0 w-full h-full rounded transition-quad overflow-hidden">
            <div class="relative w-full h-full transition-quad">
                <div v-if="backgroundType === 'image'" class="w-full h-full" :class="baseColor">
                    <picture>
                        <source media="(min-width: 1200px)" :srcset="imageLarge" />
                        <source media="(min-width: 768px)" :srcset="imageMedium" />
                        <img class="w-full h-full object-cover" :class="imageBlend" :src="imageSmall" :alt="title" />
                    </picture>

                    <div class="absolute inset-0 w-full h-full" :class="`${secondaryColor} ${colorBlend}`"></div>
                </div>

                <div v-else-if="backgroundType === 'video'" class="w-full h-full">
                    <img
                        class="lg:hidden w-full h-full object-cover"
                        :src="imageSmall ? imageSmall : poster"
                        :alt="title"
                    />

                    <video
                        class="hidden lg:block w-full h-full object-cover"
                        autoplay
                        muted
                        loop
                        playsinline
                        :poster="poster"
                    >
                        <source :src="mp4" type="video/mp4" />
                        <source v-if="webm" :src="webm" type="video/webm" />
                    </video>
                </div>
            </div>
        </div>

        <!-- π ----
        // :: TITLE
        // : ---------------------------------- -->
        <div class="relative flex flex-col items-center">
            <div class="relative mx-6 overflow-hidden">
                <div
                    class="absolute inset-0 w-full h-full transition-quad"
                    :class="this.$parent.answer === this.selection ? 'bg-red' : 'bg-transparent'"
                ></div>
                <h4
                    class="relative inline-block font-bold text-2xl sm:text-3xl md:text-4xl leading-none text-white text-center mt-2 px-4"
                >
                    {{ title }}
                </h4>
            </div>
        </div>
    </button>
</template>

<script>
export default {
    props: [
        'selection',
        'title',
        'backgroundType',
        'imageSmall',
        'imageMedium',
        'imageLarge',
        'mp4',
        'webm',
        'poster',
        'baseColor',
        'secondaryColor',
        'imageBlend',
        'colorBlend',
    ],

    methods: {
        update() {
            this.$parent.answer = this.selection
        },
    },
}
</script>
